// ============================================================
// dev-core-web/src/main.tsx
// Version: 1.1.0
// Purpose:
//   - entry point React-приложения dev-core-web
//   - монтирует <App /> в #root
//   - подключает глобальный CSS (Tailwind)
//
// Правила:
//   - единственная точка mount
//   - StrictMode обязателен
//   - никаких side effects на уровне модуля
//   - никаких секретов
// ============================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// ------------------------------------------------------------
// Root element
// ------------------------------------------------------------
const container = document.getElementById('root');

if (!container) {
  throw new Error(
    'Root element #root not found. ' +
      'Make sure index.html contains <div id="root"></div>.',
  );
}

// ------------------------------------------------------------
// Mount
// ------------------------------------------------------------
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ------------------------------------------------------------
// HMR (Vite)
// ------------------------------------------------------------
// Vite сам обрабатывает HMR для React через @vitejs/plugin-react.
// Дополнительный код не нужен.